import { render, staticRenderFns } from "./acojRender.vue?vue&type=template&id=7b6c53a4&scoped=true&"
import script from "./acojRender.vue?vue&type=script&lang=js&"
export * from "./acojRender.vue?vue&type=script&lang=js&"
import style0 from "./acojRender.vue?vue&type=style&index=0&id=7b6c53a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6c53a4",
  null
  
)

export default component.exports